// Pillar.jsx
import React from "react";
import "./Pillar.css";

const Pillar = () => {
  const buttons = [
    {
      title: "Admin Order List",
      url: "https://www.thehexaplay.com/AdminOrderlist",
    },
    {
      title: "Room Card Panel",
      url: "https://www.thehexaplay.com/AdminPanelRoomCard",
    },
    {
      title: "Admin Panel",
      url: "https://www.thehexaplay.com/AdminPanel",
    },
  ];

  const handleRedirect = (url) => {
    window.location.href = url;
  };

  return (
    <div className="pillar-container">
      <div className="pillar-card">
        <h1 className="pillar-title">Admin Menu</h1>

        <div className="pillar-buttons">
          {buttons.map((item, index) => (
            <button
              key={index}
              className="pillar-btn"
              onClick={() => handleRedirect(item.url)}
            >
              {item.title}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Pillar;